// extracted by mini-css-extract-plugin
module.exports = {"BreakpointMedium":"750px","TextBlue":"#004258","title":"_1L4dU","container":"f-oHA","logo":"_1Ds7L","text":"_2P6fO"};